import { API_PLAN_ORDER, SERVICE_ID_TO_API_PLAN } from './constants'

function sortApiPlans(tokens) {
  const orderIndex = id => {
    const i = API_PLAN_ORDER.indexOf(id)
    return i === -1 ? 999 : i
  }
  return [...new Set(tokens)].sort((a, b) => orderIndex(a) - orderIndex(b))
}

function toEffectiveDateIso(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') {
    return dateStr
  }
  const trimmed = dateStr.trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return `${trimmed}T00:00:00.000Z`
  }
  return trimmed
}

function parseGracePeriod(gracePeriodDays) {
  if (gracePeriodDays === '' || gracePeriodDays == null) {
    return null
  }
  const s = String(gracePeriodDays).trim()
  if (s === '') {
    return null
  }
  const n = Number(s)
  return Number.isFinite(n) ? n : null
}

function trimCustomPlanName(customPlanName) {
  if (customPlanName == null) {
    return null
  }
  const t = String(customPlanName).trim()
  return t ? t : null
}

/**
 * Builds the POST body for subsidiaries/manage-plan.
 * Always includes gracePeriod, isAutoPay, and customPlanName so the API receives them on every billing cycle.
 */
export function buildManagePlanPayload({
  serviceIds,
  billingCycle,
  billingId,
  packageFee,
  setupFee,
  premiumSupport,
  premiumSupportFee,
  effectiveDate,
  gracePeriodDays,
  autoPayEnabled,
  customPlanName,
  subsidiaryId,
  dashboardUserId
}) {
  const plans = sortApiPlans(
    serviceIds.map(id => SERVICE_ID_TO_API_PLAN[id]).filter(Boolean)
  )

  const nameForApi = trimCustomPlanName(customPlanName)

  const payload = {
    billingCycle,
    plans,
    packageFee: Number(packageFee) || 0,
    setupFee: Number(setupFee) || 0,
    premiumSupport: !!premiumSupport,
    premiumSupportFee: premiumSupport ? Number(premiumSupportFee) || 0 : 0,
    effectiveDate: toEffectiveDateIso(effectiveDate),
    gracePeriod: parseGracePeriod(gracePeriodDays),
    isAutoPay: !!autoPayEnabled,
    customPlanName: nameForApi
  }

  if (subsidiaryId) {
    payload.subsidiaryId = subsidiaryId
  }
  if (dashboardUserId != null && dashboardUserId !== '') {
    const uid = Number(dashboardUserId)
    if (!Number.isNaN(uid)) {
      payload.dashboardUserId = uid
    }
  }

  return payload
}
